import $ from 'jquery';
import Gravatar from '../modules/gravatar';

function initializeGravatar() {
  const $gravatar = $('.js-gravatar');

  if ($gravatar.length) {
    new Gravatar($gravatar);
  }
}

export default initializeGravatar;
